import maroonbridal from "../assets/maroonbridal.jpg";
import bridalchuda from "../assets/bridalchudatwo.png";
import kundan from "../assets/kundannecklace.png";
import earrings from "../assets/earrings.png";
import southindian from "../assets/southindiannecklace.png";
import crystalnecklace from "../assets/crystalnecklace.png";
import braclete from "../assets/bracletkada.jpeg";
import oxidised from "../assets/oxidisednecklace.png";
import goldplatedhaar from "../assets/goldplatedhaar.png";
import kangan from "../assets/kangan.png";
import maangtikka from "../assets/maangtikka.png";
import nosepin from "../assets/nosepin.png";
import longhaar from "../assets/goldplatedlongset.png";
import ring from "../assets/ring.jpg";
import shortmala from "../assets/shortmala.png";

// BRIDAL JEWELERY SET
import goldenbridalset from "../assets/bridaljewelryset/goldenbridalset.png";
import pinkbridalset from "../assets/bridaljewelryset/pinbridalset.jpg";
import greenbridalset from "../assets/bridaljewelryset/greenbridalset.jpg";
import redbridalset from "../assets/bridaljewelryset/redbridalset.jpg";

// BRIDAL CHOODA
import bridalchudaone from "../assets/bridalchooda/greenchuda.png";
import bridalchudatwo from "../assets/bridalchooda/multichudaone.png";
import bridalchudathree from "../assets/bridalchooda/redchudaone.png";
import bridalchudafour from "../assets/bridalchooda/yellowchudaone.png";
import bridalchudafive from "../assets/bridalchooda/multichudatwo.png";
import bridalchudasix from "../assets/bridalchooda/yellowchudatwo.png";
import bridalchudaseven from "../assets/bridalchooda/redchudatwo.png";
import bridalchudaeight from "../assets/bridalchooda/yellowchudathree.png";
import bridalchudanine from "../assets/bridalchooda/redlatkanchuda.png";

// KUNDAN SET
import kundansetone from "../assets/kundanset/kundansetone.png";
import kundansettwo from "../assets/kundanset/kundansettwo.png";

// CRYSTAL NECKLACE
import crystalone from "../assets/crystalnecklace/crystalone.png";
import crystaltwo from "../assets/crystalnecklace/crystaltwo.png";
import crystalthree from "../assets/crystalnecklace/crystalthree.jpeg";
import crystalfour from "../assets/crystalnecklace/crystalfour.png";
import crystalfive from "../assets/crystalnecklace/crystalfive.png";
import crystalsix from "../assets/crystalnecklace/crystalsix.png";

// RINGS
import ringone from "../assets/rings/ringone.jpg";
import ringtwo from "../assets/rings/ringtwo.jpg";
import ringthree from "../assets/rings/ringthree.jpg";

// EARRINGS
import earringone from "../assets/earrings/oearringone.png";
import earringtwo from "../assets/earrings/oearringtwo.png";
import earringthree from "../assets/earrings/oearringthree.png";
import earringfour from "../assets/earrings/oearringfour.png";
import earringfive from "../assets/earrings/oearringfive.png";
import earringsix from "../assets/earrings/oearringsix.png";
import earringseven from "../assets/earrings/oearringseven.png";
import earringeight from "../assets/earrings/oearringeight.png";
import earringnine from "../assets/earrings/oearringnine.png";

// BRACELET
import braceletone from "../assets/braclete/braceletone.jpeg";

// MAANGTIKA
import maangtikaone from "../assets/maangtika/maangtikaone.png";
import maangtikatwo from "../assets/maangtika/maangtikatwo.png";

// NOSEPIN
import nosepinone from "../assets/nosepin/nosepinone.png";
import nosepintwo from "../assets/nosepin/nosepintwo.png";

// OXIDISED JEWEL
import oxidisedone from "../assets/oxidisednecklace/oxidisedone.png";
import oxidisedtwo from "../assets/oxidisednecklace/oxidisedtwo.png";

// SHORT NECKLACE
import shortone from "../assets/shortnecklace/shortnaclace1.png";
import shorttwo from "../assets/shortnecklace/shortnaclace2.png";
import shortfour from "../assets/shortnecklace/shortnaclace4.png";
import shortfive from "../assets/shortnecklace/shortnaclace5.png";

// GOLD PLATED HAAR
import goldplatedhaarone from "../assets/goldplatedhaar/goldplatedhaarone.png";
import goldplatedhaartwo from "../assets/goldplatedhaar/goldplatedhaartwo.png";
import goldplatedhaarthree from "../assets/goldplatedhaar/goldplatedhaarthree.png";
import goldplatedhaarfour from "../assets/goldplatedhaar/goldplatedhaarfour.png";

// LONG HAAR
import longone from "../assets/longhaar/Long Haar 1.png";
import longtwo from "../assets/longhaar/Long Haar 2.png";
import longfour from "../assets/longhaar/Long Haar 4.png";
import longfive from "../assets/longhaar/Long Haar 5.png";

// SOUTH INDIAN JEWELS
import southindianone from "../assets/southindianjewelry/southindianone.png";
import southindiantwo from "../assets/southindianjewelry/southindiantwo.png";
import southindianthree from "../assets/southindianjewelry/southindianthree.png";
import southindianfour from "../assets/southindianjewelry/southindianfour.png";

// BANGLES
import bangalone from "../assets/bangles/bangaleone.png";
import bangaltwo from "../assets/bangles/bangaletwo.png";
import bangalthree from "../assets/bangles/bangalthree.png";
import bangalfour from "../assets/bangles/bangalefour.png";

export const jewelleryProducts = [
  {
    id: 1,
    name: "Marron Bridal Jewellery Set",
    category: "Bridal Jewellry Set",
    price: 1299,
    image: maroonbridal,
    isNew: false,
    inStock: true,
  },
  {
    id: 2,
    name: "Red Bridal Chooda",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchuda,
    isNew: true,
    inStock: true,
  },
  {
    id: 3,
    name: "Emerald Necklace Set",
    category: "Necklace Set",
    price: 1299,
    image: kundan,
    isNew: false,
    inStock: true,
  },
  {
    id: 4,
    name: "Crystal Necklace Set",
    category: "Crystal Necklace",
    price: 1299,
    image: crystalnecklace,
    isNew: true,
    inStock: true,
  },
  {
    id: 5,
    name: "Royal Enamel Jhumkas",
    category: "Earrings",
    price: 1299,
    image: earrings,
    isNew: true,
    inStock: true,
  },
  {
    id: 6,
    name: "Antique Heritage Long Haar Set",
    category: "Long-Haar",
    price: 1299,
    image: longhaar,
    isNew: false,
    inStock: true,
  },
  {
    id: 7,
    name: "Majestic Regal Bracelet",
    category: "Bracelet",
    price: 1299,
    image: braclete,
    isNew: false,
    inStock: true,
  },
  {
    id: 8,
    name: "Short Necklace Set",
    category: "Short Necklace",
    price: 1299,
    image: shortmala,
    isNew: false,
    inStock: true,
  },
  {
    id: 9,
    name: "Regal Bangles Pair",
    category: "Bangles",
    price: 1299,
    image: kangan,
    isNew: false,
    inStock: true,
  },
  {
    id: 10,
    name: "Twinkling Elegant Rings",
    category: "Rings",
    price: 1599,
    image: ring,
    isNew: false,
    inStock: true,
  },
  {
    id: 11,
    name: "Ethereal South Indian Set",
    category: "South-Indian Jewelry",
    price: 1599,
    image: southindian,
    isNew: false,
    inStock: true,
  },
  {
    id: 12,
    name: "Heritage Filigree Maangtika",
    category: "Maangtika",
    price: 1299,
    image: maangtikka,
    isNew: false,
    inStock: true,
  },
  {
    id: 13,
    name: "Traditional Classic Nath with Chain",
    category: "Nosepin",
    price: 1299,
    image: nosepin,
    isNew: false,
    inStock: true,
  },
  {
    id: 14,
    name: "Oxidised Necklace Set",
    category: "Oxidised Necklace",
    price: 1299,
    image: oxidised,
    isNew: false,
    inStock: true,
  },
  {
    id: 15,
    name: "Emerald Gold-Plated Set",
    category: "Gold-Plated Haar",
    price: 1299,
    image: goldplatedhaar,
    isNew: false,
    inStock: true,
  },
];

// BRIDAL JEWELERY SET
export const category = [
  // BRIDAL CHOODA
  {
    id: 16,
    name: "Royal Green Bridal Chooda",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudaone,
    isNew: false,
    inStock: true,
  },
  {
    id: 17,
    name: "Heritage Multicolor Bridal Set",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudatwo,
    isNew: false,
    inStock: true,
  },
  {
    id: 18,
    name: "Traditional Red Bridal Kada Set",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudathree,
    isNew: false,
    inStock: true,
  },
  {
    id: 19,
    name: "Classic Yellow Bridal Chooda",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudafour,
    isNew: false,
    inStock: true,
  },
  {
    id: 20,
    name: "Royal Meenakari Bridal Kada Set",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudafive,
    isNew: false,
    inStock: true,
  },
  {
    id: 21,
    name: "Premium Yellow Bridal Bangle Set",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudasix,
    isNew: false,
    inStock: true,
  },
  {
    id: 22,
    name: "Majestic Maroon Bridal Chooda",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudaseven,
    isNew: false,
    inStock: true,
  },
  {
    id: 23,
    name: "Regal Golden Stone Bridal Bangle Set",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudaeight,
    isNew: false,
    inStock: true,
  },
  {
    id: 24,
    name: "Grand Red Heavy Bridal Chooda",
    category: "Bridal Chooda",
    price: 1299,
    image: bridalchudanine,
    isNew: false,
    inStock: true,
  },

  // NECKLACE SET
  {
    id: 25,
    name: "Heritage Pearl Multicolor Necklace Set",
    category: "Necklace Set",
    price: 1299,
    image: kundansetone,
    isNew: false,
    inStock: true,
  },
  {
    id: 26,
    name: "Majestic Pink Stone Necklace Set",
    category: "Necklace Set",
    price: 1299,
    image: kundansettwo,
    isNew: false,
    inStock: true,
  },

  // CRYSTAL NECKLACE
  {
    id: 27,
    name: "Royal Blue Crystal Necklace Set",
    category: "Crystal Necklace",
    price: 1299,
    image: crystalone,
    isNew: false,
    inStock: true,
  },
  {
    id: 28,
    name: "Emerald Elite Crystal Necklace Set",
    category: "Crystal Necklace",
    price: 1299,
    image: crystaltwo,
    isNew: false,
    inStock: true,
  },
  {
    id: 29,
    name: "Rose Gold Luxe Crystal Necklace Set",
    category: "Crystal Necklace",
    price: 1299,
    image: crystalthree,
    isNew: false,
    inStock: true,
  },
  {
    id: 30,
    name: "Elite Y-Shape Crystal Necklace Set",
    category: "Crystal Necklace",
    price: 1299,
    image: crystalfour,
    isNew: false,
    inStock: true,
  },
  {
    id: 31,
    name: "Regal Gold Crystal Necklace Set",
    category: "Crystal Necklace",
    price: 1299,
    image: crystalfive,
    isNew: false,
    inStock: true,
  },
  {
    id: 32,
    name: "Elegant Floral Crystal Necklace Set",
    category: "Crystal Necklace",
    price: 1299,
    image: crystalsix,
    isNew: false,
    inStock: true,
  },

  // RINGS
  {
    id: 33,
    name: "Antique Rajwadi Stone Ring",
    category: "Rings",
    price: 1299,
    image: ringone,
    isNew: false,
    inStock: true,
  },
  {
    id: 34,
    name: "Royal Pink Stone Kundan Ring",
    category: "Rings",
    price: 1299,
    image: ringtwo,
    isNew: false,
    inStock: true,
  },
  {
    id: 35,
    name: "Heritage Polki Lotus Ring",
    category: "Rings",
    price: 1299,
    image: ringthree,
    isNew: false,
    inStock: true,
  },

  // EARRINGS
  {
    id: 36,
    name: "Emerald Meenakari Jhumka Earrings",
    category: "Earrings",
    price: 1299,
    image: earringone,
    isNew: false,
    inStock: true,
  },
  {
    id: 37,
    name: "Oxidised Tribal Square Studs",
    category: "Earrings",
    price: 1299,
    image: earringseven,
    isNew: false,
    inStock: true,
  },
  {
    id: 38,
    name: "Heritage Kundan Statement Danglers",
    category: "Earrings",
    price: 1299,
    image: earringthree,
    isNew: false,
    inStock: true,
  },
  {
    id: 39,
    name: "Majestic Chandbali Drop Set",
    category: "Earrings",
    price: 1299,
    image: earringfive,
    isNew: false,
    inStock: true,
  },
  {
    id: 40,
    name: "Royal Heritage Long Jhumkas",
    category: "Earrings",
    price: 1299,
    image: earringtwo,
    isNew: false,
    inStock: true,
  },

  {
    id: 41,
    name: "Floral Antique Jhumka Earrings",
    category: "Earrings",
    price: 1299,
    image: earringsix,
    isNew: false,
    inStock: true,
  },
  {
    id: 42,
    name: "Royal Dome Jhumka Set",
    category: "Earrings",
    price: 1299,
    image: earringeight,
    isNew: false,
    inStock: true,
  },
  {
    id: 43,
    name: "Heritage Antique Jhumkas",
    category: "Earrings",
    price: 1299,
    image: earringfour,
    isNew: false,
    inStock: true,
  },
  {
    id: 44,
    name: "Elegant Circle Drop Jhumkas",
    category: "Earrings",
    price: 1299,
    image: earringnine,
    isNew: false,
    inStock: true,
  },

  // BRACELET
  {
    id: 45,
    name: "Imperial Luxe Bracelet",
    category: "Bracelet",
    price: 1299,
    image: braceletone,
    isNew: false,
    inStock: true,
  },

  // MAANGTIKA
  {
    id: 46,
    name: "Traditional Gold Pendant Maangtika",
    category: "Maangtika",
    price: 1299,
    image: maangtikaone,
    isNew: false,
    inStock: true,
  },
  {
    id: 47,
    name: "Antique Leaf Motif Maangtika",
    category: "Maangtika",
    price: 1299,
    image: maangtikatwo,
    isNew: false,
    inStock: true,
  },

  // NOSEPIN
  {
    id: 48,
    name: "Royal Flower Drop Nath",
    category: "Nosepin",
    price: 1299,
    image: nosepinone,
    isNew: false,
    inStock: true,
  },
  {
    id: 49,
    name: "Heritage Leaf-Edge Nath",
    category: "Nosepin",
    price: 1299,
    image: nosepintwo,
    isNew: false,
    inStock: true,
  },

  // OXIDISED JEWEL
  {
    id: 50,
    name: "Tribal Oxidized Pendant Necklace",
    category: "Oxidised Necklace",
    price: 1299,
    image: oxidisedone,
    isNew: false,
    inStock: true,
  },
  {
    id: 51,
    name: "Ethnic Oxidized Round Pendant Necklace",
    category: "Oxidised Necklace",
    price: 1299,
    image: oxidisedtwo,
    isNew: false,
    inStock: true,
  },

  // SHORT NECKLACE
  {
    id: 52,
    name: "Majestic Heritage Necklace",
    category: "Short Necklace",
    price: 1299,
    image: shortfive,
    isNew: false,
    inStock: true,
  },
  {
    id: 53,
    name: "Antique Regal Short Necklace",
    category: "Short Necklace",
    price: 1299,
    image: shortone,
    isNew: false,
    inStock: true,
  },
  {
    id: 54,
    name: "Green Beaded Royal Necklace",
    category: "Short Necklace",
    price: 1299,
    image: shorttwo,
    isNew: false,
    inStock: true,
  },
  {
    id: 55,
    name: "Red Heritage Short Necklace",
    category: "Short Necklace",
    price: 1299,
    image: shortfour,
    isNew: false,
    inStock: true,
  },

  // GOLD PLATED HAAR
  {
    id: 56,
    name: "Traditional Fringe V-Neck Haar",
    category: "Gold-Plated Haar",
    price: 1299,
    image: goldplatedhaartwo,
    isNew: true,
    inStock: true,
  },
  {
    id: 57,
    name: "Heritage Choker Necklace Set",
    category: "Gold-Plated Haar",
    price: 1299,
    image: goldplatedhaarone,
    isNew: false,
    inStock: true,
  },
  {
    id: 58,
    name: "Elegant Polki-Style Collar Set",
    category: "Gold-Plated Haar",
    price: 1299,
    image: goldplatedhaarthree,
    isNew: false,
    inStock: true,
  },
  {
    id: 59,
    name: "Delicate Pendant Necklace Set",
    category: "Gold-Plated Haar",
    price: 1299,
    image: goldplatedhaarfour,
    isNew: false,
    inStock: true,
  },

    {
    id: 60,
    name: "Heritage Golden Wedding Jewellery Set",
    category: "Bridal Jewellry Set",
    price: 1299,
    image: goldenbridalset,
    isNew: true,
    inStock: true,
  },
    {
    id: 61,
    name: "Pink Rajwadi Bridal Jewellery Set",
    category: "Bridal Jewellry Set",
    price: 1299,
    image: pinkbridalset,
    isNew: false,
    inStock: true,
  },
  {
    id: 62,
    name: "Emerald Green Bridal Jewellery Set",
    category: "Bridal Jewellry Set",
    price: 1299,
    image: greenbridalset,
    isNew: false,
    inStock: true,
  },
  {
    id: 63,
    name: "Traditional Red Bridal Jewellery Set",
    category: "Bridal Jewellry Set",
    price: 1299,
    image: redbridalset,
    isNew: false,
    inStock: true,
  },

  // LONG HAAR
  {
    id: 64,
    name: "Majestic Heritage Long Haar Set",
    category: "Long-Haar",
    price: 1299,
    image: longone,
    isNew: false,
    inStock: true,
  },
  {
    id: 65,
    name: "Antique Maharani Long Haar & Earrings Set",
    category: "Long-Haar",
    price: 1299,
    image: longtwo,
    isNew: false,
    inStock: true,
  },
  {
    id: 66,
    name: "Grand Royal Nakshi Long Necklace Set",
    category: "Long-Haar",
    price: 1299,
    image: longfour,
    isNew: false,
    inStock: true,
  },
  {
    id: 67,
    name: "Classic Antique Mango Long Haar Set",
    category: "Long-Haar",
    price: 1299,
    image: longfive,
    isNew: false,
    inStock: true,
  },

  // SOUTH INDIAN JEWEL
  {
    id: 68,
    name: "Kemp Round Temple Necklace Set",
    category: "South-Indian Jewelry",
    price: 1299,
    image: southindiantwo,
    isNew: false,
    inStock: true,
  },
  {
    id: 69,
    name: "Royal South-Indian Temple Pendant Set",
    category: "South-Indian Jewelry",
    price: 1299,
    image: southindianone,
    isNew: false,
    inStock: true,
  },
  {
    id: 70,
    name: "Royal Antique Gaja-Lakshmi Set",
    category: "South-Indian Jewelry",
    price: 1299,
    image: southindianthree,
    isNew: false,
    inStock: true,
  },
  {
    id: 71,
    name: "Antique South-Indian Bridal Temple Set",
    category: "South-Indian Jewelry",
    price: 1299,
    image: southindianfour,
    isNew: true,
    inStock: true,
  },

  // BANGLES
  {
    id: 72,
    name: "Traditional Maroon Stone Kada Set",
    category: "Bangles",
    price: 1299,
    image: bangaltwo,
    isNew: false,
    inStock: true,
  },
  {
    id: 73,
    name: "Royal Blue Kundan Bangles",
    category: "Bangles",
    price: 1299,
    image: bangalone,
    isNew: false,
    inStock: true,
  },
  {
    id: 74,
    name: "Royal Golden Heritage Kada Set",
    category: "Bangles",
    price: 1299,
    image: bangalthree,
    isNew: false,
    inStock: true,
  },
  {
    id: 75,
    name: "Blush Pink Kundan Bangles",
    category: "Bangles",
    price: 1299,
    image: bangalfour,
    isNew: false,
    inStock: true,
  },
];

// CLEAN, SEO-FRIENDLY CATEGORY LIST
export const categories = [
  { id: "all", name: "All Products" },
  { id: "bridal", name: "Bridal Jewellery Set" },
  { id: "kundan-set", name: "Kundan Set" },
  { id: "necklace", name: "Necklace Sets" },
  { id: "earrings", name: "Earrings" },
  { id: "bracelet", name: "Bracelets" },
  { id: "rings", name: "Rings" },
  { id: "bangles", name: "Bangles" },
  { id: "long-haar", name: "Long Haar Sets" },
  { id: "south-indian", name: "South Indian Sets" },
  { id: "maangtikka", name: "Maangtikka" },
  { id: "nosepin", name: "Nosepin" },
  { id: "oxidised", name: "Oxidised Sets" },
  { id: "gold-plated", name: "Gold Plated Sets" },
];
